import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import {formatDuration} from 'helpers/formatter';

const formatTime = val =>
  `${val === 0 ? 12 : val > 12 ? val - 12 : val}:00 ${val < 13 ? 'A' : 'P'}M`;

class TimePicker extends React.Component {
  constructor(props) {
    super(props);

    const times = [];

    if (props.duration) {
      const timeVariations = [0, 5, 15, 30];

      for (let i = 0; i <= 12; i++) {
        for (let j = 0; j < timeVariations.length; j++) {
          times.push(i * 60 + timeVariations[j]);
        }
      }
    } else {
      for (let i = 0; i < 24; i++) {
        times.push(i);
      }
    }

    this.state = {times};
  }

  handleChange = value => this.props.onChange(Number(value));

  render() {
    const {times} = this.state;
    const {value, duration} = this.props;

    return (
      <Select
        clearable={false}
        labelKey="label"
        onChange={x => this.handleChange(x.value)}
        options={times.map(x => {
          return {
            label: duration ? formatDuration(x) : formatTime(x),
            value: x,
          };
        })}
        placeholder=""
        searchable={false}
        value={value}
        valueKey="value"
      />
    );
  }
}

TimePicker.defaultProps = {
  duration: false,
  value: null,
};

TimePicker.propTypes = {
  duration: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  // functions
  onChange: PropTypes.func.isRequired,
};

export default TimePicker;



// WEBPACK FOOTER //
// ./src/components/Common/Form/TimePicker.js